import { consumWep, weapon } from "./weapon";
import { item } from "./item";
export var Condition;
(function (Condition) {
    Condition[Condition["DEAD"] = 0] = "DEAD";
    Condition[Condition["WOUND_HIGH"] = 1] = "WOUND_HIGH";
    Condition[Condition["WOUND_MEDIUM"] = 2] = "WOUND_MEDIUM";
    Condition[Condition["WOUND_LOW"] = 3] = "WOUND_LOW";
    Condition[Condition["HEALTHY"] = 4] = "HEALTHY";
})(Condition || (Condition = {}));
export default class Contestant {
    //these will be customizable eventually
    constructor(theName, thePronoun, theObjpronoun, thePospronoun, theImage) {
        //lists of body parts contestants can be hit in. syntax: "[name] was hit in the [bodypart]"
        this.bodylight = ["ear", "nose", "hand", "foot", "finger", "toe", "cheek"];
        this.bodymed = ["forearm", "shin", "thigh", "calf", "shoulder", "hip", "rib", "jaw"];
        this.bodyheavy = ["head", "neck", "guts", "chest", "face", "back"];
        this.name = theName;
        this.cond = Condition.HEALTHY; //todo
        this.kills = 0;
        this.pronoun = thePronoun;
        this.objpronoun = theObjpronoun;
        this.pospronoun = thePospronoun;
        this.wep = new weapon("fists", 0, 0, "punches", 2, 0);
        this.consumWeps = [];
        this.items = [];
        this.isInGroup = false;
        this.image = theImage;
        this.pronounCustomToggle = false;
    }
    getName() {
        return this.name;
    }
    getCond() {
        return this.cond;
    }
    getKills() {
        return this.kills;
    }
    getPronoun() {
        return this.pronoun;
    }
    getObjpronoun() {
        return this.objpronoun;
    }
    getPospronoun() {
        return this.pospronoun;
    }
    isGroup() {
        return false;
    }
    setName(the) {
        this.name = the;
    }
    setPronoun(the) {
        this.pronoun = the;
    }
    setObjPronoun(the) {
        this.objpronoun = the;
    }
    setPosPronoun(the) {
        this.pospronoun = the;
    }
    setCond(newCond) {
        this.cond = newCond;
    }
    upCond(up) {
        if (this.cond + up > 4) {
            this.cond = 4;
        }
        else {
            this.cond += up;
        }
    }
    downCond(down) {
        if (this.cond - down < 0) {
            this.cond = 0;
        }
        else {
            this.cond -= down;
        }
    }
    setKills(newKills) {
        this.kills = newKills;
    }
    upKills(up) {
        this.kills += up;
    }
    getCondName() {
        switch (this.cond) {
            case Condition.DEAD:
                return "dead";
            case Condition.WOUND_HIGH:
                return "heavily wounded";
            case Condition.WOUND_MEDIUM:
                return "wounded";
            case Condition.WOUND_LOW:
                return "lightly wounded";
            case Condition.HEALTHY:
                return "healthy";
            default:
                return "error";
        }
    }
    getWeapon() {
        return this.wep;
    }
    //if new weapon is better, replace and return true, otherwise keep current weapon and return false
    newWeapon(x) {
        if (x.getHitAdd() > this.wep.getHitAdd()) {
            this.wep = x;
            return true;
        }
        return false;
    }
    getConsumWeps() {
        return this.consumWeps;
    }
    newConsumWeapon(x) {
        if (x.getHitAdd() > this.wep.getHitAdd()) {
            this.consumWeps.push(x);
            return true;
        }
        return false;
    }
    loseWeapon() {
        this.wep = new weapon("fists", 0, 0, "hits", 2, 0);
    }
    loseConsumWep(x) {
        if (this.consumWeps.length > 0) {
            this.consumWeps.splice(x, 1);
            return true;
        }
        return false;
    }
    getItems() {
        return this.items;
    }
    addItem(x) {
        this.items.push(x);
    }
    loseItem(x) {
        if (this.items.length > 0) {
            this.items.splice(x, 1);
            return true;
        }
        return false;
    }
    setIsInGroup(x) {
        this.isInGroup = x;
    }
    getIsInGroup() {
        return this.isInGroup;
    }
    //passed a singular and plural string, returns the correct one based on pronoun
    verbSwitchPro(x, y) {
        if (this.pronoun == "they") {
            return y;
        }
        else {
            return x;
        }
    }
    //passed a singular and plural string, returns the correct one based on whether object is contestant or group (polymorphic w/ group object)
    verbSwitchName(x, y) {
        return x;
    }
    //TODO: improve type checking so this isn't needed
    getString() {
        return "Error: getString called on a solo contestant";
    }
    setImage(x) {
        this.image = x;
    }
    getImage() {
        return [this.image];
    }
    getPronounCustomToggle() {
        return this.pronounCustomToggle;
    }
    setPronounCustomToggle(x) {
        this.pronounCustomToggle = x;
    }
}
